<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div
    :class="wrapperClasses"
    @mouseenter="loopVideo ? (show = true) : (show = false)"
    @mouseleave="loopVideo ? (show = false) : (show = false)"
  >
    <div
      ref="playerRef"
      class="absolute h-auto w-full inset-0 [&_iframe]:absolute [&_iframe]:w-full [&_iframe]:h-full"
    />
    <!-- <PlayButton
      v-if="show"
      @handle-click="togglePlay"
      :label="label"
      classes="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    /> -->
  </div>
</template>

<script lang="ts" setup>
import Player from "@vimeo/player";
import { computed, ref, Ref, onMounted, toRefs } from "vue";
import PlayButton from "@atoms/PlayButton/PlayButton.ce.vue";

export interface VimeoPlayerProps {
  videoId: number;
  portrait: boolean;
  loop?: boolean;
}

type Emits = {
  (e: "click"): void;
};
const emit = defineEmits<Emits>();
const props = defineProps<VimeoPlayerProps>();

const { videoId, portrait, loop } = toRefs(props);
const playerRef: Ref<HTMLIFrameElement | null> = ref(null);
let player: Player;
let label = ref("Play");
let show = ref(true);

onMounted(() => {
  const options = {
    id: videoId.value,
    title: false,
    vimeo_logo: false,
    portrait: portrait.value,
    progress_bar: false,
    volume: true,
    transcript: false,
    pip: false,
    cc: false,
    fullscreen: false,
    controls: !loop?.value,
    loop: loop?.value,
    autoplay: loop?.value,
    muted: loop?.value,
    autopause: !loop?.value,
  };

  if (loop?.value) {
    show.value = false;
    label.value = "Pause";
  } else {
    show.value = false;
  }

  if (!playerRef.value) return;
  player = new Player(playerRef.value, options);
  player.ready().then();
  // player.on("pause", () => {
  //   if (loop?.value) {
  //     label.value = "Play";
  //   }
  // });
});

function play() {
  if (!player) return;
  player.play();
  label.value = "Pause";
}

function pause() {
  if (!player) return;
  player.pause();
  label.value = "Play";
}

function togglePlay() {
  player.getPaused().then(function (paused) {
    if (paused) {
      play();
    } else {
      pause();
    }
  });
}

const loopVideo = computed(() => {
  return loop?.value;
});
const showControles = computed(() => {
  return !loopVideo.value;
});

const wrapperClasses = computed(() => {
  const aspectRatio = portrait.value ? "aspect-portrait" : "aspect-video";
  return `relative w-full h-auto ${aspectRatio}`;
});
</script>
